import React, { useState } from 'react';
import { Modal, Form, Button, ListGroup, InputGroup } from 'react-bootstrap';

/**
 * OrgSelectorModal - Allows superadmins to select which organization to view
 * @param {boolean} show - Control visibility
 * @param {array} organizations - List of available orgs [{hash, name}]
 * @param {function} onSelect - Callback when org is selected (receives org object)
 */
const OrgSelectorModal = ({ show, organizations = [], onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOrg, setSelectedOrg] = useState(null);

  // Filter organizations based on search
  const filteredOrgs = organizations.filter(org =>
    org.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = () => {
    if (selectedOrg) {
      onSelect(selectedOrg);
      setSearchTerm('');
      setSelectedOrg(null);
    }
  };

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      size="md"
    >
      <Modal.Header style={{ borderTop: '4px solid #1abc9c' }}>
        <Modal.Title>Select Organization</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          As a superadmin, please select which organization you want to view:
        </p>

        {/* Search Input */}
        <InputGroup className="mb-3">
          <InputGroup.Text>
            <i className="fas fa-search"></i>
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Search organizations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </InputGroup>

        {/* Organization List */}
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {filteredOrgs.length > 0 ? (
            <ListGroup>
              {filteredOrgs.map((org) => (
                <ListGroup.Item
                  key={org.hash}
                  active={selectedOrg?.hash === org.hash}
                  onClick={() => setSelectedOrg(org)}
                  style={{ cursor: 'pointer' }}
                  action
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{org.name}</strong>
                      <br />
                      <small className="text-muted">{org.hash}</small>
                    </div>
                    {selectedOrg?.hash === org.hash && (
                      <i className="fas fa-check-circle" style={{ color: '#1abc9c' }}></i>
                    )}
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <div className="text-center text-muted py-4">
              <i className="fas fa-search" style={{ fontSize: '2rem' }}></i>
              <p className="mt-2">No organizations found</p>
            </div>
          )}
        </div>

        {/* Selected Org Info */}
        {selectedOrg && (
          <div className="mt-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
            <small className="text-muted">Selected:</small>
            <br />
            <strong>{selectedOrg.name}</strong>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={handleSelect}
          disabled={!selectedOrg}
          style={{ backgroundColor: '#1abc9c', borderColor: '#1abc9c' }}
        >
          Continue as {selectedOrg?.name || '...'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrgSelectorModal;